import React, { useRef, useState, useEffect } from "react";
import "./SongsSection.css";

import bgTexture from "../../assets/Group17.png";
import micImg from "../../assets/Group3.png";
import cardPaper from "../../assets/paper.png";

import ahwakImg from "../../assets/img1.png";
import gabbarImg from "../../assets/img2.png";
import anaLakImg from "../../assets/img3.png";
import SongCard from "../../components/Songcard/SongCard";



const SongsSection = () => {
  const sectionRef = useRef(null);
  const [showSongs, setShowSongs] = useState(false);

  const songsData = [
    {
      image: ahwakImg,
      title: "AHWAK",
      year: "1953",
      desc: "One of Abdel Halim’s most famous romantic songs",
      extraClass: "cardOne",
    },
    {
      image: gabbarImg,
      title: "GABBAR",
      year: "1967",
      desc: "A powerful song that reflects heartbreak and strong emotional expression",
      extraClass: "cardTwo",
    },
    {
      image: anaLakImg,
      title: (
        <>
          ANA LAK
          <br />
          ALATOL
        </>
      ),
      year: "1960",
      desc: "A powerful song that reflects heartbreak and strong emotional expression",
      extraClass: "cardThree",
    },
  ];

  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowSongs(true);
          observer.unobserve(currentSection);
        }
      },
      { threshold: 0.25 }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`songsSection ${showSongs ? "showSongsSection" : ""}`}
      id="songs"
    >
      <img src={bgTexture} className="songsBg" alt="background" />

      <div className="songsContent">
        <div className="songsHeader">
          <h2 className="songsTitle">The Sound of a Generation</h2>

          <p className="songsSubtitle">
            Songs that shaped generations and defined
            <br />
            the golden era of Arabic music
          </p>
        </div>

        <div className="songsCardsWrapper">
          {songsData.map((song, index) => (
            <SongCard
              key={index}
              paper={cardPaper}
              image={song.image}
              title={song.title}
              year={song.year}
              desc={song.desc}
              extraClass={song.extraClass}
            />
          ))}

          <img src={micImg} className="songsMic" alt="microphone" />
        </div>
      </div>
    </section>
  );
};

export default SongsSection;